// extracted by mini-css-extract-plugin
export default {"select-pet-item":"select-pet-item_select-pet-item__MQOvk","pet-img":"select-pet-item_pet-img__hbZO1"};